/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
// React
import React, { useEffect, useState } from "react"
import { Button, Card, Col, Collapse, Container, Row } from "react-bootstrap"
import { Link, useHistory, useLocation, withRouter } from "react-router-dom"

import DisplaySearchConditionLabel from "../../components/DisplaySearchConditionLabel"

import Spinner from "../../components/Spinner"
import ComboBox from "../../components/ComboBox"
import TextInput from "../../components/InputWrapper/TextInput"

import * as gridPageHelper from "../../ts/helpers/gridPageHelper"
import * as pageHelper from "../../ts/helpers/pageHelper"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../type/wijmoComponents"
import { clearAlert, setAlerts } from "../../globalStore/alertStore"
import { AppDispatch } from "../.."
import { useDispatch } from "react-redux"
import AlertComponent from "../../components/AlertComponent"
import { showInfoToast } from "../../components/CustomToast"
import ConfirmModal from "../../components/Modal/ConfirmModal"
import { TApiResponse } from "../../service/TApiResponse"

import { 区分マスタ } from "../../service/master/kubun/TKubun"
import {
  TAyanasQueryGetListReq,
  TAyanasQueryGetListRes,
} from "../../service/ayanasQuery/TAyanasQuery"
import AyanasQueryService from "../../service/ayanasQuery/ayanasQueryService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronDown,
  faChevronUp,
  faExternalLinkAlt,
  faPen,
  faPlay,
} from "@fortawesome/free-solid-svg-icons"
import { faPlusSquare, faTrashAlt } from "@fortawesome/free-regular-svg-icons"
import { 画面ロック解除, 画面ロック開始 } from "../../globalStore/progressStore"
import FlexGridOuter from "../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../constant"
import KubunService from "../../service/master/kubun/kubunService"
import { T区分マスタ } from "../../components/ComboBox/KubunComboBox"
import { 区分分類コード } from "../../constant/enum/codes"

/**
 * Ayanas Query　TOP
 * @return React.FC
 */
const AyanasQueryTop: React.FC = () => {
  const history = useHistory()
  const location = useLocation()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  const firstQuery: TAyanasQueryGetListReq = queryString.parse(location.search)

  let gridId = "AyanasQueryTop_GridId"

  const [accordionController, setAccordionController] = useState(true)

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TAyanasQueryGetListRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        const pageIndex = flexGrid!.itemsSource!.pageIndex
        setPageNumber(pageIndex)
      },
      groupDescriptions: [
        new wjCore.PropertyGroupDescription(
          "公開範囲",
          (i: TAyanasQueryGetListRes) => i.公開範囲区分名称
        ),
      ],
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TAyanasQueryGetListReq) => {
    setSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TAyanasQueryGetListReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    // APIより値を取得する
    // sessionの作成
    const service = new AyanasQueryService()
    try {
      const res = await service.getList({
        ...currentSearchCondition,
      })
      dispatch(setAlerts(res))

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setSearching(false)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TAyanasQueryGetListReq = queryString.parse(location.search)
    set公開範囲区分(query.公開範囲区分 ?? "")
    setクエリ名(query.クエリ名 ?? "")
    setタグ(query.タグ ?? "")
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TAyanasQueryGetListReq => {
    return {
      クエリ名,
      公開範囲区分: 公開範囲区分 ?? undefined,
      タグ,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TAyanasQueryGetListReq
  ) => {
    return {
      公開範囲: 区分ItemSource?.find(
        (i) =>
          i.分類コード === 区分分類コード.AyanasQuery.公開範囲区分 &&
          i.区分コード === searchCondition.公開範囲区分
      )?.名称1,
      クエリ名: searchCondition.クエリ名,
      タグ: searchCondition.タグ,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    if (公開範囲ComboBox) 公開範囲ComboBox.selectedIndex = 0
    setクエリ名("")
    setタグ("")

    // フィルターのクリア
    if (!searching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // Alertのクリア
    dispatch(clearAlert())
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  /**
   * 削除管理
   */
  const updateDelete = async () => {
    if (searching || !selectedRow) return
    setSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    const service = new AyanasQueryService()

    try {
      const res: TApiResponse<any> = await service.delete(
        selectedRow.AQクエリID
      )
      if (res) {
        showInfoToast("削除しました。")
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setSearching(false)
      setIsConfirmModalShow(false)
      search()
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  // グリッド初期化フラグ
  const [flexGridInitialized, setFlexGridInitialized] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [searching, setSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [state]
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // コンボボックス退避用
  const [公開範囲ComboBox, set公開範囲ComboBox] = useState<TWijmoComboBox<
    string,
    区分マスタ
  > | null>(null)
  const [公開範囲isLoadEnded, set公開範囲isLoadEnded] = useState<boolean>(false)
  // 検索条件用

  const [クエリ名, setクエリ名] = useState<string>(firstQuery.クエリ名 ?? "")
  const [公開範囲区分, set公開範囲区分] = useState<string | null>(
    firstQuery.公開範囲区分 ?? null
  )
  const [タグ, setタグ] = useState<string>(firstQuery.タグ ?? "")

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [selectedRow, setSelectedRow] = useState<TAyanasQueryGetListRes>()

  const [initializedComboBoxData, setInitializedComboBoxData] = useState(false)
  //#endregion

  //#region [baseComponentHandler]

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {}

  //#endregion

  //#region [effect]

  /**
   * 初期挙動時に画面ロック開始
   */
  useEffect(() => {
    dispatch(画面ロック開始())
    Promise.all([new KubunService().getList()]).then(([kubunRes]) => {
      set区分ItemSource([...kubunRes.data])
      setInitializedComboBoxData(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (flexGridInitialized && 公開範囲ComboBox && initializedComboBoxData) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [flexGridInitialized, 公開範囲ComboBox, initializedComboBoxData])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">Ayanas Query クエリ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className={"w-40rem"}>
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <form>
                  <Container className="search-condition-main" fluid>
                    <Row>
                      {/* 公開範囲 */}
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <ComboBox.Kubun
                              分類コード={
                                区分分類コード.AyanasQuery.公開範囲区分
                              }
                              placeholder="公開範囲"
                              isAllSelect={true}
                              isRequired={true}
                              ComboBox={公開範囲ComboBox}
                              setComboBox={set公開範囲ComboBox}
                              itemsSource={区分ItemSource}
                              selectedValue={公開範囲区分}
                              setSelectedValue={set公開範囲区分}
                              isLoadEnded={公開範囲isLoadEnded}
                              setIsLoadEnded={
                                set公開範囲isLoadEnded
                              }></ComboBox.Kubun>
                            {/* クエリ名 text */}
                            <TextInput
                              id="UserListクエリ名"
                              name="クエリ名"
                              value={クエリ名}
                              setValue={setクエリ名}
                              maxLength={20}
                              placeholder="クエリ名"
                            />
                            {/* ＃タグ text */}
                            <TextInput
                              id="UserListタグ"
                              name="タグ"
                              value={タグ}
                              setValue={setタグ}
                              maxLength={15}
                              placeholder="タグ"
                            />
                          </div>
                          {/* 検索ボタン */}
                          <Button
                            type="submit"
                            disabled={searching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              search()
                            }}>
                            検索
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={searching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              {/* itemSourceに検索済み想定のGridData設定 */}
              <Row className="grid-content-row">
                <Col className="grid-content">
                  <FlexGridOuter
                    flexGrid={flexGrid}
                    setFlexGrid={setFlexGrid}
                    gridConstantProperties={
                      CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                    }
                    gridData={gridData}
                    setGridData={setGridData}
                    pageNumber={pageNumber}
                    searchConditionClear={searchConditionClear}
                    gridId={gridId}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={flexGridInitialized}
                    setGridInitialized={setFlexGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    gridInitializedHandler={gridInitializedHandler}
                    formatItem={formatItem}
                    headerComponent={
                      <Link
                        to="/AyanasQuery/Query"
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={searching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          <span>新規追加</span>
                        </Button>
                      </Link>
                    }>
                    <wjrGrid.FlexGridColumn
                      binding="クエリ名称"
                      width={190}
                      header="クエリ名"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="ユーザー氏名"
                      width={140}
                      header="作成者"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="作成日時"
                      width={160}
                      header="作成日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: any) => {
                          return (
                            <>
                              {wjCore.Globalize.format(
                                new Date(context.item.作成日時),
                                "G"
                              )}
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="タグ"
                      width={200}
                      header="タグ">
                      {/* TODO:タグ用の加工 */}
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      header=" "
                      allowMerging="true"
                      align="left"
                      width={380}
                      allowResizing={false}
                      selectable={false}
                      isReadOnly>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TAyanasQueryGetListRes>
                        ) => {
                          // TODO: ページ遷移等のクリックイベントの修正
                          return (
                            <>
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                style={{
                                  marginLeft: "0.5rem",
                                  marginRight: "0.5rem",
                                }}
                                onClick={() => {
                                  // 画面全体のスクロール位置の保存
                                  gridPageHelper.savePageConditionData(
                                    location.pathname
                                  )
                                  // ヒストリー追加
                                  history.push(
                                    `/AyanasQuery/Query/${context.item.AQクエリID}?run=1`
                                  )
                                }}>
                                <FontAwesomeIcon icon={faPlay} />
                                <span>実行</span>
                              </Button>
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                style={{
                                  marginLeft: "0.5rem",
                                  marginRight: "0.5rem",
                                }}
                                onClick={() => {
                                  // 画面全体のスクロール位置の保存
                                  gridPageHelper.savePageConditionData(
                                    location.pathname
                                  )
                                  // 別タブ開いて移動 ヒストリー追加
                                  window.open(
                                    `${window.location.origin}${
                                      process.env.PUBLIC_URL ?? ""
                                    }/AyanasQuery/Query/${
                                      context.item.AQクエリID
                                    }?run=1`
                                  )
                                }}>
                                <FontAwesomeIcon icon={faExternalLinkAlt} />
                                <span>別タブ実行</span>
                              </Button>
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                style={{
                                  marginLeft: "0.5rem",
                                  marginRight: "0.5rem",
                                }}
                                variant="working"
                                onClick={() => {
                                  // 画面全体のスクロール位置の保存
                                  gridPageHelper.savePageConditionData(
                                    location.pathname
                                  )
                                  // ヒストリー追加
                                  history.push(
                                    `/AyanasQuery/Query/${context.item.AQクエリID}`
                                  )
                                }}>
                                <FontAwesomeIcon icon={faPen} />
                                <span>変更</span>
                              </Button>
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                style={{
                                  marginLeft: "0.5rem",
                                  marginRight: "0.5rem",
                                }}
                                variant="caution"
                                onClick={() => {
                                  // 画面全体のスクロール位置の保存
                                  gridPageHelper.savePageConditionData(
                                    location.pathname
                                  )
                                  setSelectedRow(context.item)
                                  //TODO: 削除
                                  setIsConfirmModalShow(true)
                                }}>
                                <FontAwesomeIcon icon={faTrashAlt} />
                                <span>削除</span>
                              </Button>
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={updateDelete}>
        {selectedRow?.クエリ名称} を{selectedRow?.削除フラグ ? "復元" : "削除"}
        しますか？
      </ConfirmModal>
    </Container>
  )
}

export default withRouter(AyanasQueryTop)
